<template>
  <section class="hero">
    <div class="hero-content">
      <h1>À propos de EasyGO</h1>
      <p>Venez nous rencontrer.</p>
    </div>
  </section>
  <section class="page-container page-content">
    <!-- <article> -->
    <!--   <img src="../assets/images/diverse-friends-students-shoot.jpg" alt="Photo de Groupe" /> -->
    <!--   <h2>Nos racines franco-camerounaises</h2> -->
    <!--   <p>Originaire du Cameroun et basée en France, notre entreprise familiale maintient son siège -->
    <!--     social sur notre terre d'origine. L'identité visuelle de notre projet s'inspire d'ailleurs -->
    <!--     directement des couleurs du drapeau camerounais. Nous croyons profondément en l'avenir de -->
    <!--     l'Afrique et sommes convaincus que la valorisation des transports en commun est un moteur -->
    <!--     essentiel pour le développement local. -->
    <!--   </p> -->
    <!--   <h2>Une équipe engagée</h2> -->
    <!--   <p>Notre équipe à taille humaine se compose de quatre membres, dont Georges et Alexandra, qui -->
    <!--     participent chacun au développement du projet avec leur propre expertise. Nos deux -->
    <!--     développeurs mettent tout en œuvre au quotidien pour concevoir une application de -->
    <!--     réservation robuste et extrêmement simple d'utilisation pour vos recherches de trajets. -->
    <!--   </p> -->
    <!--   <img src="../assets/images/diverse-friends-students-shoot.jpg" alt="Photo de Groupe" /> -->
    <!--   <h2>Notre vision technologique</h2> -->
    <!--   <p>Mus par une volonté constante d’innover, nous remanions et améliorons des technologies de -->
    <!--     pointe disponibles à travers le continent africain. Cela nous permet de proposer un système -->
    <!--     de gestion de tickets dématérialisés garantissant des services courants, intégrés et souples -->
    <!--     dans différentes régions. -->
    <!--   </p> -->
    <!--   <h2>Notre mission au quotidien</h2> -->
    <!--   <p>Notre objectif principal est de créer un lien direct et fiable entre les compagnies de -->
    <!--     transport et les utilisateurs, qu'ils soient des voyageurs locaux ou des touristes. En -->
    <!--     facilitant l'accès et l'achat de titres de transport en ligne, nous encourageons l'usage du -->
    <!--     transport en commun tout en améliorant significativement les expériences de voyage au -->
    <!--     quotidien. -->
    <!--   </p> -->
    <!-- </article> -->
    <article>
      <img src="../assets/images/diverse-friends-students-shoot.jpg" alt="Photo de Groupe" />
      <h2>Repenser la mobilité africaine</h2>
      <p>
        <strong>EasyGO</strong> n'est pas qu'une simple application de réservation, c'est le nouveau standard technologique du voyage sur le continent. Née d'une forte synergie franco-camerounaise, notre plateforme transforme la manière dont les usagers recherchent et achètent leurs tickets de transport au quotidien. Nous sommes convaincus que la modernisation de ces infrastructures est un levier majeur pour accélérer le développement économique local.
      </p>
      <h2>Une fiabilité à toute épreuve</h2>
      <p>
        Pour mériter votre confiance chaque jour, notre équipe agile construit une infrastructure logicielle extrêmement simple d'utilisation et d'une grande solidité technique. Nos développeurs réinventent les standards de qualité afin de garantir que chaque trajet commence par une réservation sans aucun stress. Faire le choix d'<strong>EasyGO</strong>, c'est opter pour un partenaire de confiance qui valorise et facilite l'accès aux transports en commun.
      </p>
      <h2>L'innovation au service du voyage</h2>
      <p>
        Nous déployons des technologies de pointe pour offrir une expérience numérique fluide, rapide et parfaitement transparente aux utilisateurs. Notre mission est de numériser les titres de transport tout en créant un lien direct et fiable entre les compagnies et les voyageurs. En supprimant les frictions liées aux réservations traditionnelles, nous redonnons de la liberté et de la sérénité aux usagers locaux comme aux touristes.
      </p>
    </article>
  </section>
  <HeroSlanted title="Contact" subtitle="Un besoin, une suggestion, n'hésitez pas!" id="contact" />
  <section class="form-content">
    <div class="card">
      <ContactForm />
    </div>
  </section>
  <HeroSlanted title="Vos avis" subtitle="Votre opinion compte pour nous!" id="contact" split-top="var(--color-grey-light)" split-bottom="var(--bg-primary)" reverse/>
  <section class="ratings">
    <div class="group-rows">

  <div v-for="rating in randomRatings" :key="rating.id" class="card rating-card no-shadow">
    <!-- <span class="quote-open">❝</span> -->
    <span class="quote-close">❞</span>

    <div class="card-body">
      <span v-if="!rating.userAvatar" class="user-avatar anonymous">{{ initials }}</span>
      <span v-else class="user-avatar" :style="{ backgroundImage: `url(${config.apiUrl}/uploads/avatars/${rating.userAvatar})` }" ></span>
      <div class="content">
        <div class="user-meta">
          <div class="user-meta-left">
            <span class="user-name">{{ rating.userName }}</span>
            <span class="rating-date">{{ formattedDate }}</span>
          </div>
          <div class="stars">
            <span v-for="i in 5" :key="i" :class="{ filled: i <= rating.overallRating }">★</span>
          </div>
        </div>
        <p class="review-text">{{ rating.reviewText }}</p>
      </div>
    </div>
  </div>
  </div>

    <!-- <Carousel v-bind="carouselConfig" class="carousel-container-ratings"> -->
    <!-- <Slide v-for="rating in randomRatings" :key="rating.id"> -->
    <!-- <RatingCardCarousel :rating="rating" /> -->
    <!-- </Slide> -->
    <!-- <template #addons> -->
    <!--   <Navigation /> -->
    <!--   <Pagination /> -->
    <!-- </template> -->
    <!-- </Carousel> -->
  </section>
</template>

<script setup>
import HeroSlanted from '../components/HeroSlanted.vue';
import ContactForm from '../components/ContactForm.vue';
// import RatingCardCarousel from '@/components/RatingCardCarousel.vue'
import 'vue3-carousel/carousel.css'
import { Carousel, Slide, Pagination, Navigation } from 'vue3-carousel'
import { ref, onMounted } from 'vue'
import { config } from '@/config/env.js'

const randomRatings = ref([])

const carouselConfig = {
  itemsToShow: 1,
  snapAlign: 'start',
  wrapAround: true,
  mouseWheel: false,
  autoplay: 3000,
  pauseAutoplayOnHover: true,
}

onMounted(async () => {
  const res = await fetch(`${config.apiUrl}/ratings/random`)
  randomRatings.value = await res.json()
  console.log(randomRatings.value)
})
</script>

<style scoped>
.page-container {
  padding: 4rem 2rem;
}
.page-content {
  max-width: 1200px;
  margin: 0 auto;
}
article {
  display: block;
}
article img {
  float: right;
  border-radius: 20px;
  margin: 0 0 2rem 3rem;
  max-width: 40%;
}
article img:nth-of-type(2) {
  float: left;
  margin: 0 3rem 2rem 0;
  margin-top: 4rem;
}
article h2 {
  margin-top: 4rem;
}
article h2:first-of-type {
  margin-top: 0;
}
.form-content {
  background-color: var(--color-grey-light);
  display: flex;
  justify-content: center;
  padding: 4rem;
}
.form-content:deep(.card) {
  width: auto;
  min-width: 800px;
}
:deep(form) {
  width: auto;
}
:deep(.footer, footer) {
  margin-top: 0 !important;
  background-color: red;
}

.ratings {
  background-color: var(--bg-primary);
  padding: 3rem 4rem;
  max-width: 1200px;
  margin: 0 auto;
}

  section:last-of-type {
    padding: 4rem;
    padding-bottom: 6rem;
  }

@media (max-width: 768px) {
  article h2 {
    margin-top: 2rem;
  }
  .ratings {
    padding: 2rem 1rem;
  }
  .page-content article {
    display: flex;
    gap: 0 !important;
    /* gap: 2rem; */
  }
  article > img {
    float: none;
    display: block;
    margin: 0 auto 2rem;
    max-width: 100%;
  }

  article h2:first-of-type {
    margin-top: 3rem;
  }
  section:last-of-type {
    padding: 2rem;
  }
  .page-container {
    padding: 2rem 1.5rem;
  }
  .form-content {
    padding: 2rem 1rem;
  }
  .form-content .card {
    width: 100% !important;
    min-width: 100% !important;
  }
  .page-content article {
    gap: 2rem;
  }
}

.rating-card {
  /* padding: 2.5rem 5rem; */
  /* margin: 2rem; */
  /* box-shadow: var(--shadow-sm); */
  position: relative;
  flex: 1;
  background-color: var(--bg-primary-alpha);
  border: 1px solid var(--color-border);
}

.quote-open,
.quote-close {
  font-size: 5rem;
  line-height: 1;
  color: var(--color-feuille);
  opacity: 0.15;
  position: absolute;
  font-family: Georgia, serif;
  pointer-events: none;
}

.quote-open { top: 0.5rem; left: 0.75rem; }
/* .quote-close { bottom: 0.5rem; right: 0.75rem; } */
.quote-close {
  bottom: 1.0rem; /* ancre sur le padding-bottom */
  right: 0.75rem;
  line-height: 0; /* évite que la hauteur de ligne compte */
}

.card-body {
  display: flex;
  gap: 1.25rem;
  align-items: flex-start;
  position: relative;
  z-index: 1;
}

.user-avatar {
  width: 6rem;
  height: 6rem;
  border-radius: var(--border-radius-sm);
  background: var(--color-feuille) center / cover no-repeat;
  color: white;
  font-weight: 700;
  font-size: 0.95rem;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
  flex-shrink: 0;
}

.user-avatar.anonymous {
  width: 3rem;
  height: 3rem;
  border-radius: 50%;
}

.content {
  display: flex;
  flex-direction: column;
  gap: 0.75rem; /* était 1rem */
  flex: 1;
}

.user-meta {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.user-meta-left {
  display: flex;
  flex-direction: column;
}

.user-name {
  font-weight: 700;
  font-size: 0.9rem;
}

.rating-date {
  font-size: 0.72rem;
  color: var(--color-text-secondary);
}

.stars span { color: var(--color-border); font-size: 1.1rem; }
.stars .filled { color: #f5a623; }

.review-text {
  font-size: 1.05rem;
  font-style: italic;
  line-height: 1.8;
  color: var(--color-text);
  margin: 0;
}

.card-footer {
  display: flex;
  justify-content: flex-end;
  align-items: center;
}

.score-badge {
  font-size: 2rem;
  font-weight: 900;
  color: var(--color-feuille);
  line-height: 1;
}

.score-max {
  font-size: 1rem;
  font-weight: 400;
  color: var(--color-text-secondary);
}




</style>
